import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionId", "actionMetadata", "flowObjectTypeId", "getHeaderTitle"];
import PropTypes from 'prop-types';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import FormulaActionMetadata from 'automation-ui-action-features/actions/formula/FormulaActionMetadata';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import FormulaActionSummary from 'automation-ui-action-features/actions/formula/FormulaActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  actionMetadata: PropTypes.instanceOf(FormulaActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType.isRequired,
  getHeaderTitle: PropTypes.func.isRequired,
  getActionOutputsForTargetActionById: PropTypes.func.isRequired
};
function FormulaActionCard(_ref) {
  let {
      actionId,
      actionMetadata,
      flowObjectTypeId,
      getHeaderTitle
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, restProps, {
    content: /*#__PURE__*/_jsx(FormulaActionSummary, {
      actionMetadata: actionMetadata,
      flowObjectTypeId: flowObjectTypeId,
      getActionLabelById: getHeaderTitle
    }),
    headerTitle: getHeaderTitle({
      actionId
    })
  }));
}
FormulaActionCard.propTypes = propTypes;
export default FormulaActionCard;